import { Store } from 'libx'
import { task } from 'mobx-task'

export default class BillingScreenStore extends Store {
  activate () {
    return this.fetchCards()
  }

  @task fetchCards () {
    return this.rootStore.billingStore.fetchCards()
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/BillingScreenStore.js